import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Accordion } from './Accordion';
import { CTAButton } from './CTAButton';
import { TOMOS } from '../lib/data';
export function Modules() {
  return <section className="px-4 py-8" data-id="element-171" data-mp="1vwsi6hkzt5ir">
      <p className="text-center text-sm font-bold uppercase tracking-widest text-hockey-pink" data-id="element-172" data-mp="1vxu79pyufsjh">
        Para eso existe
      </p>
      <h2 className="mt-1 text-center font-display text-3xl leading-none text-white" data-id="element-173" data-mp="145w5pi2uh2w0">
        Hockey Pro System
      </h2>
      <p className="mx-auto mt-3 max-w-sm text-center text-sm text-white/60" data-id="element-174" data-mp="186y8u9zvtz39">
        6 tomos completos que cubren técnica, táctica, físico, prevención, portería y mentalidad.
      </p>

      <div className="mt-6 space-y-3" data-id="element-175" data-mp="1i5e0ce2tnada">
        {TOMOS.map((t, idx) => <Accordion key={t.title} emoji={t.emoji} title={t.title} defaultOpen={idx === 0} data-id="element-176" data-mp="1i3ku2zw4es5t" data-mpi={idx}>
            <ul className="space-y-2" data-id="element-177" data-mp="2onu3l0fa3xaq">
              {t.points.map(p => <li key={p} className="flex items-start gap-2 text-[14px] text-white/80" data-id="element-178" data-mp="2tj9djha6191v">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-hockey-pink" data-id="element-179" data-mp="1trvhq7q4yf8" />
                  <span data-id="element-180" data-mp="3tylv3cm93pfq">{p}</span>
                </li>)}
            </ul>
          </Accordion>)}
      </div>

      <div className="mt-6" data-id="element-181" data-mp="3oy7rc6ron1ni">
        <CTAButton label="Quiero dominar los partidos" data-id="element-182" data-mp="3k0obj2fc6gtg" />
      </div>
    </section>;
}